import React from "react";
import Personal from "./personal";
import Password from "./password";
import WalletProfileSection from "../wallet/WalletProfileSection";
import KYCStatusWidget from "./KYCStatusWidget";

const ProfilePageComponent = () => {
  // Get user token from localStorage or your auth context
  const userToken =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("access_token");

  return (
    <div className="min-h-screen bg-gray-50 p-6 mt-10">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold  mb-8">
          {" "}
          Profile Setting
        </h1>

        {/* KYC Status Widget - Identity Verification */}
        <div className="mb-8">
          <KYCStatusWidget />
        </div>

        {/* Wallet Addresses Section - New Feature */}
        <div className="mb-8">
          <div className="border-2 border-[#2A356D] rounded-lg">
            <WalletProfileSection userToken={userToken} />
          </div>
        </div>

        {/* Main content area - two columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <div className="bg-white rounded-lg shadow-sm border-2 border-[#2A356D]">
            <Personal />
          </div>
          {/* Right Column - Password Change */}
          <div className="bg-white rounded-lg shadow-sm border-2 border-[#2A356D]">
            <Password />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePageComponent;
